import { render } from "./NotFoundPage.vue?vue&type=template&id=3af1a1e5&scoped=true"
const script = {}

import "./NotFoundPage.vue?vue&type=style&index=0&id=3af1a1e5&scoped=true&lang=css"

import exportComponent from "/home/ubuntu/Proyectos/Vue/cotizador-ventus/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3af1a1e5"]])

export default __exports__